import { isProd } from './index'

export default {
  projectId: '2oiwztas',
  apiVersion: '2022-08-25',
  dataset: 'production',
  useCdn: isProd,
  globalHelper: true,
}
